module.exports = __webpack_public_path__ + "static/images/jf-yyt.cee2110.png";